import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, Typography } from '@mui/material';
import { startTransition } from 'react';
import { useFilterEvents } from '../../../../../OffersFilter/useFilterEvents';
import { useGetOffersFilterOffers } from '../../../../components/OffersFilter/store';

export const SeeMoreRatesButton = ({
  visibleOffersCount,
  onClick,
  analyticsProps,
}: {
  visibleOffersCount: number;
  onClick: () => void;
  analyticsProps: {
    actionSection: string;
    pageIdentifier: string;
  };
}) => {
  const { showMoreButtonClickEvent } = useFilterEvents({
    actionSection: analyticsProps.actionSection,
    pageIdentifier: analyticsProps.pageIdentifier,
    additionalAttributes: {},
  });
  const allOffers = useGetOffersFilterOffers();

  const handleButtonClick = () => {
    startTransition(() => {
      onClick();
      showMoreButtonClickEvent();
    });
  };

  const showEmptyState = visibleOffersCount === 0;
  const disableShowMoreButton = allOffers.length <= visibleOffersCount;
  const displayedCount = Math.min(visibleOffersCount, allOffers.length);

  if (showEmptyState) return null;

  return (
    <Box>
      <Box sx={{ display: 'flex', pt: 3, justifyContent: 'center' }}>
        <Button
          onClick={handleButtonClick}
          disabled={disableShowMoreButton}
          disableRipple
          disableFocusRipple
          disableTouchRipple
          sx={{
            backgroundColor: 'white',
            border: '1px solid',
            borderColor: 'primary.main',
            height: '48px',
            width: 'fit-content',
            px: 3,
            py: '14px',
            color: 'primary.main',
            '&:disabled': {
              borderColor: 'neutral.light',
              backgroundColor: 'white',
              color: 'neutral.light',
            },
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              component="span"
              sx={{
                textTransform: 'uppercase',
                fontWeight: 500,
                fontSize: '14px',
                color: 'inherit',
              }}
            >
              See more rates
            </Typography>
            <ExpandMoreIcon
              sx={{
                fontSize: 24,
                color: 'inherit',
              }}
            />
          </Box>
        </Button>
      </Box>
      <Typography sx={{ fontSize: '14px', color: 'neutral.dark', mt: 1.5, textAlign: 'center' }}>
        Showing {displayedCount} of {allOffers.length}{' '}
        {allOffers.length === 1 ? 'rate' : 'rates'}
      </Typography>
    </Box>
  );
};
